import Api from '@services/API';

/**
 * Service responsible for requesting new access codes.
 * Points to the specific Access Code API (outside ERP context).
 */
export default class NewAccessCode extends Api {

    /**
     * Base endpoint for access code requests.
     * Note: No '/erp' prefix as requested.
     * @type {String}
     */
    static base = '/api/new-access-code';

    /**
     * Resource suffix (empty for the base endpoint).
     * @type {String}
     */
    static resource = '';

    /**
     * @param {String} resource - Resource suffix to append to base.
     * @param {Object} options - Axios config options.
     * @param {Object} http - Custom axios instance if needed.
     */
    constructor(resource, options = {}, http = null) {
        // Normalizes the base + resource ensuring URL flexibility
        super(NewAccessCode.normalize(NewAccessCode.base, resource), options, http);
    }

    /**
     * Factory method to build the service instance.
     * @return {NewAccessCode}
     */
    static build() {
        return new this(this.resource);
    }

    /**
     * Requests a new access code generation.
     * @param {Object} data - Payload required for code generation.
     * @param {String} data.email
     * @param {String} [data.system_operational]
     * @param {String} [data.browser]
     * @returns {Promise} Axios response promise.
     */
    create(data) {
        return this.post('', data);
    }
}